<template>
    <div id="HomeHeader">
        <div class="h-100">
            <div class="container h-100">
                <div  class="home-banner-container row align-items-center justify-content-center">
                    <div id="HomeBanner" class="col h-100">
                        <BannerCopy :banner="bannerList" />
                        
                    </div>
                </div>
            </div>
        </div>
        
        <BannerBg :banner="bannerList" />
        <div id="TyreFinder" class="col">
            <TyreFinder />
        </div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import BannerCopy from './BannerCopy.vue';
    import BannerBg from './BannerBackground.vue';
    import TyreFinder from './TyreFinder.vue';

    export default {
        components: {
            TyreFinder,
            BannerCopy,
            BannerBg,
        },
        data() {
            return {
                bannerList: []
            };
        },
        computed: {
        },
        watch: {
            banner: {
                handler() {
                    this.bannerList = this.getBanner();
                }
            }
        },
        apollo: {
            banner: {
                query: gql`
                    {
                      banner(where: {displayText: "Home Page Banner"}) {
                        bannerSlides {
                          contentItems {
                            ... on BannerSlide {
                              displayText
                              slideCopy
                              slideCopyColour
                              slideImageDarken
                              slideImage {
                                urls(first: 1)
                              }
                              slideImageMobile {
                                urls(first: 1)
                              }
                              slideLink {
                                text
                                url
                              }
                              slideLinkColour
                              foregroundImagePositioning
                              slideForegroundImage {
                                urls(first: 1)
                              }
                            }
                          }
                        }
                      }
                    }
                `,
            }
        },
        methods: {
            getBanner() {
                var bannerObj = this.banner[0].bannerSlides.contentItems;
                if (bannerObj.length <= 0) bannerObj = null;

                return bannerObj;
            },
            getBaseUrl() {
                if (window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1) return 'https://dunloptyres-oc-qa.azurewebsites.net';

                return process.env.VUE_APP_CMS_BASE_URL;
            },
        },
    };
</script>